import BaseModelVesting from "@/models/BaseModelVesting.js";

export const VestingEventGridConfig = {
	list: BaseModelVesting.list,
	columns: BaseModelVesting.columns,
	query: {
		batchQuery:true,
        filter : function(o){
			return  (o.WorkflowStatus == 'Pending' || o.WorkflowStatus == 'Processing' || o.WorkflowStatus == 'Error')
			//o.SpecialArrangement != "Overridden" &&
			
        },
		limit: 5000
	},
	grid: {		
		gridId:'vestingGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: true,		
		document:true,                       
		groupable: true,
		actionsColumnWidth:120
	}
}

export const VestingEventToolbarConfig = {
	list: 'ToolBarItems',
	items: [   
			{
				id:"btnApproveVesting",
				type: "button",
				text: "Approve Vesting",
				showIcon: "toolbar",
				icon: "check-circle",
				attributes: { "class": "float-right-btn btn btn-primary" }
			},             
			{
					id:"btnAddVesting",
					type: "button",
					text: "Add Special Vesting",
					showIcon: "toolbar",
					icon:"plus-circle",
					attributes: { "class": "float-right-btn btn btn-secondary" }
			},
			{
				id:"btnBulkImportVesting",
				type: "button",
				text: "Bulk Import",
				showIcon: "toolbar",
				icon:"upload",
				attributes: { "class": "float-right-btn btn btn-tertiary" },
		},		      
		{
			id: "btnBulkAttachment",
			type: "button",
			text: "Attach Documents",
			showIcon: "toolbar",
			icon: "attachment",
			attributes: {
				"class": "float-right-btn btn btn-light", "style":"background: #fff;"
			}
		},
	]
}

export const VestingUpdateConfig = {
	list: "Vesting",
	columns: {
	  Id: {
		dataName: "Id",
		type: "number"
	  },
	  Status: {
		dataName: "Status",
		type: "string"
	  },
	  VestingLogged: {
		dataName: 'VestingLogged',
		type: 'string',
	  }

	}
  };